// Diagnostic script to check Elasticsearch connectivity
import ApiService from '../services/api-service';

export const checkElasticSearchHealth = async () => {
  console.log('=== Elasticsearch Diagnostic Check ===');
  
  try {
    // Test 1: Try a simple search
    console.log('Test 1: Testing search endpoint...');
    const testKeyword = 'test';
    const response = await ApiService.SEARCH(testKeyword);
    console.log('Search response:', response);
    
    if (response && response.result) {
      console.log('✓ Search endpoint is responding');
      console.log('Results found:', {
        music: response.result.music?.length || 0,
        artist: response.result.artist?.length || 0,
        studio: response.result.studio?.length || 0
      });
    } else {
      console.log('✗ Search endpoint returned unexpected format');
    }
  } catch (error) {
    console.error('✗ Search endpoint error:', error);
    
    // Check if it's a connection error
    if (error.message && error.message.includes('Network')) {
      console.error('Network error - Backend might be down');
    } else if (error.response && error.response.status === 503) {
      console.error('503 Service Unavailable - Elasticsearch might be down');
    } else if (error.response && error.response.status === 500) {
      console.error('500 Internal Server Error - Possible Elasticsearch connection issue');
    }
    
    console.log('\nPossible solutions:');
    console.log('1. Check if Elasticsearch service is running on the backend');
    console.log('2. Restart Elasticsearch: sudo systemctl restart elasticsearch');
    console.log('3. Check Elasticsearch logs: sudo journalctl -u elasticsearch -f');
    console.log('4. If using Searchkick, reindex data: rails searchkick:reindex:all');
    console.log('5. Check backend logs for connection errors');
  }
  
  // Test 2: Try individual search endpoints
  console.log('\nTest 2: Testing individual search endpoints...');
  const endpoints = [
    { name: 'User Search', method: 'SEARCH_USER', keyword: 'test' },
    { name: 'Music Search', method: 'SEARCH_MUSIC', keyword: 'test' },
    { name: 'Artist Search', method: 'SEARCH_ARTIST', keyword: 'test' }
  ];
  
  for (const endpoint of endpoints) {
    try {
      const result = await ApiService[endpoint.method](endpoint.keyword);
      console.log(`✓ ${endpoint.name} is working`);
    } catch (error) {
      console.log(`✗ ${endpoint.name} failed:`, error.message);
    }
  }
};

// Add this to window for easy console access
if (typeof window !== 'undefined') {
  window.checkElasticSearch = checkElasticSearchHealth;
}